module.exports = __webpack_public_path__ + "static/media/stift.e99e42c8.svg";